import { PaymentStatus, TransactionEventStatus, TransactionEventType } from '@seapoint/server/enums';
import useSWR from 'swr';
import { getSwrFetcher } from '../utils/get-swr-fetcher';

const POLLING_INTERVAL = 1000;
const TRANSACTIONS_API_PATH = '/api/transactions';

type TransactionEvent = {
  id: string;
  type: TransactionEventType;
  occurredAt: string;
  title: string;
  description?: string | null;
  status: TransactionEventStatus;
};

export type PaymentTimelineResponse = {
  transactionId: string;
  currentStatus: PaymentStatus;
  institutionName: string | null;
  isoStatusCode: string | null;
  isoStatusName: string | null;
  events: TransactionEvent[];
};

export const usePaymentTimeline = (transactionId: string | null) => {
  const { data, error, isLoading } = useSWR<PaymentTimelineResponse, Error, string | null>(
    transactionId ? `${TRANSACTIONS_API_PATH}/${transactionId}/events` : null,
    getSwrFetcher,
    {
      refreshInterval: (data) => {
        if (!data) {
          return POLLING_INTERVAL;
        }

        return isPaymentStatusFinal(data.currentStatus) ? 0 : POLLING_INTERVAL;
      },
      refreshWhenHidden: true,
    },
  );

  return {
    timeline: data,
    isLoading,
    error,
    isFinalStatus: data ? isPaymentStatusFinal(data.currentStatus) : false,
  };
};

const isPaymentStatusFinal = (status: PaymentStatus): boolean => {
  return status === PaymentStatus.SUCCEEDED || status === PaymentStatus.FAILED;
};
